import React, { useEffect, useState } from 'react';
import { Badge, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import bakingApi from '../services/bakingApi';

/**
 * Minimal open-recommendation summary for project/job detail pages.
 * Advisory only — no Apply/Run/Fix controls.
 */
function OpenRecommendationsPanel({ projectId, revisionId, jobId }) {
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const params = { status: 'open' };
        if (projectId) params.project = projectId;
        if (revisionId) params.revision = revisionId;
        if (jobId) params.job = jobId;
        const data = await bakingApi.listAiRecommendations(params);
        if (!cancelled) setItems(Array.isArray(data) ? data.slice(0, 5) : []);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load recommendations');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [projectId, revisionId, jobId]);

  if (error || items.length === 0) return null;

  const aiLink = jobId
    ? `/console/ai?job=${jobId}`
    : `/console/ai?project=${projectId || ''}${revisionId ? `&revision=${revisionId}` : ''}`;

  return (
    <div className="product-card mb-3" data-testid="open-ai-recommendations">
      <h2 className="h6">Open AI recommendations</h2>
      <p className="small text-muted mb-2">
        Advisory only — accepting advice does not change this project or run jobs.{' '}
        <Link to={aiLink}>Open AI Technical Artist</Link>
      </p>
      <ListGroup variant="flush">
        {items.map((rec) => (
          <ListGroup.Item key={rec.id} className="px-0">
            <Badge bg="secondary" className="me-1">
              {rec.severity}
            </Badge>
            {rec.title}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
}

export default OpenRecommendationsPanel;
